
import React from 'react';
import { motion } from 'framer-motion';

interface SecurityFeatureCardProps {
  feature: {
    icon: React.ReactNode;
    title: string;
    description: string;
  };
  index: number;
}

const SecurityFeatureCard = ({ feature, index }: SecurityFeatureCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.2, duration: 0.6 }}
      viewport={{ once: true }}
      className="bg-white/5 backdrop-blur-xl p-6 md:p-8 rounded-xl md:rounded-2xl border border-white/10 hover:border-white/30 transition-all duration-300"
    >
      <div className="flex items-center mb-4 md:mb-6">
        {feature.icon}
        <h3 className="text-lg md:text-2xl font-bold text-white ml-3 md:ml-4">
          {feature.title}
        </h3>
      </div>
      <p className="text-sm md:text-base text-gray-300 leading-relaxed">
        {feature.description}
      </p>
    </motion.div>
  );
};

export default SecurityFeatureCard;
